export enum EServicesErrorCode {
  CART_STOCK_EXCEED = 'SFE1505',
  CART_DEBT_BLOCKED = 'SFE1508',
  CHECKOUT_BAD_USER_CONFIGURATION = 'SFE1516',
  CART_BAD_ADDRESS_CONFIGURATION = 'SFE1511',
  CART_BAD_MINIMUM_SALE_QTY_CONFIGURATION = 'SFE1512',
  CART_NOT_VALID_VISIT_DAY = 'SFE1400',
}
